import { Injectable } from '@angular/core';
import { GoogleMap } from '@angular/google-maps';

export interface MapBounds {
  south: number;
  west: number;
  north: number;
  east: number;
}

@Injectable({
  providedIn: 'root'
})
export class TenantFarmBoundsService {

  private _bounds: MapBounds | null = null;
  private _googleMapComponent: GoogleMap | null = null;
  private _mapData: any | null = null;
  private _farmLabelMarkers = [];
  private _isFarmLabelMarkerVisible: boolean = false;

  set bounds(bounds: MapBounds) {
    this._bounds = bounds;
  }

  get bounds(): MapBounds | null {
    return this._bounds;
  }

  //set GoogleMap  conponent
  set googleMapComponent(mapComponent: GoogleMap) {
    this._googleMapComponent = mapComponent;
  }

  get googleMapComponent(): GoogleMap | null {
    return this._googleMapComponent;
  }

    //set GoogleMap  data
  set googleMapData(mapData: any) {
    this._mapData = mapData;
  }

  get googleMapData(): GoogleMap | null {
    return this._mapData;
  }


  //set label markers
    set tenantFarmLabels(farmLabels: any ){
    this._farmLabelMarkers = farmLabels;
    // console.log(farmLabels, 'set farmLabels');
  }

  get tenantFarmLabels(): any | null {
    return this._farmLabelMarkers;
  }


    //set label toggle
    set isTenantFarmLabelVisible(farmLabelVisible: boolean ){
    this._isFarmLabelMarkerVisible = farmLabelVisible;
  }

  get isTenantFarmLabelVisible(): boolean | null {
    return this._isFarmLabelMarkerVisible;
  }
  
  fitBounds(): boolean {

    if (this._bounds && this._googleMapComponent) {
      try {
        this._googleMapComponent.fitBounds(this._bounds); // or panToBounds 
        // console.log('Successfully called fitBounds on GoogleMap component');
        return true;
      } catch (error) {
        console.error('Error calling fitBounds:', error);
        return false;
      }
    } else {
      // console.log('Missing requirements - bounds:', !!this._bounds, 'googleMapComponent:', !!this._googleMapComponent);
      return false;
    }
  }

  //Clear previous tenant data when switching tenants from nav bar
  clearTeanatviewMap() {      
    this.clearFarmNameLabels();
    this.clearFarmFieldBoundaries();
  }

  clearFarmNameLabels(){
        // Remove farm labels when switching tenents or toggle farm labels
    if(!this._isFarmLabelMarkerVisible){
        this._farmLabelMarkers.forEach(marker => marker.setMap(null));
        this._farmLabelMarkers = [];
    }
  }

  clearFarmFieldBoundaries(){
    // Clear farm/field boundaries
    this._googleMapComponent.data.forEach((item) => {
      this._googleMapComponent.data.remove(item);
    }) 
}


//Pan to  -perhaps for future farm / field level upgrade
  // panTo(latLng: google.maps.LatLng | google.maps.LatLngLiteral): boolean {
  //   if (this._googleMapComponent) {
  //     this._googleMapComponent.panTo(latLng);
  //     return true;
  //   }
  //   return false;
  // }

  //Zoom Control 
  // setZoom(zoom: number): boolean {
  //   if (this._googleMapComponent) {
  //     this._googleMapComponent.zoom = zoom;
  //     return true;
  //   }
  //   return false;
  // }
  
}
